module.exports = __webpack_public_path__ + "fonts/roboto-bold-webfont.woff";